export default __webpack_public_path__ + "static/media/close_btn.0890c2ba.svg";